import { EMPTY_FIELD } from 'support/helpers/const/const';
import { Tooltip, TooltipContent, TooltipTrigger } from 'components/Display/Tooltip/Tooltip';

export type RelatedOrderMessage = {
  id: string;
  externalRef: string;
};

type RelatedOrdersProps = {
  relatedOrderMessages?: Array<RelatedOrderMessage>;
};

export function RelatedOrders({ relatedOrderMessages }: RelatedOrdersProps) {
  const relatedOrderExternalMessageRefs = relatedOrderMessages
    ?.map(({ externalRef }) => externalRef)
    .filter(Boolean)
    .join(', ');

  if (!relatedOrderExternalMessageRefs) {
    return <>{EMPTY_FIELD}</>;
  }

  return (
    <Tooltip enabled={Boolean(relatedOrderExternalMessageRefs.length)}>
      <TooltipTrigger>
        <span className="block max-w-52 truncate">{relatedOrderExternalMessageRefs}</span>
      </TooltipTrigger>
      <TooltipContent>{relatedOrderExternalMessageRefs}</TooltipContent>
    </Tooltip>
  );
}
